/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
import Cookies from 'js-cookie';
import axios from '@shared/config/baseAPI';

const deviceId = Cookies.get('deviceId'); // change this with your device id
const userToken = Cookies.get('token'); // token from cookies

export const getUser = async (username, uid) => {
  const userTokenUpdate = Cookies.get('token');
  const formData = new FormData();
  const urlEncode = 'application/x-www-form-urlencoded';
  if (username) {
    formData.append('username', username);
  }
  if (uid) {
    formData.append('uid', uid);
  }

  if (userTokenUpdate) {
    try {
      return await axios.post('/user/profile', formData, { headers: { 'Content-Type': `${urlEncode}`, 'device-id': `${deviceId}`, 'x-kumu-auth': `${userTokenUpdate}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  } else {
    try {
      return await axios.post('/user/profile', formData, { headers: { 'Content-Type': `${urlEncode}`, 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};

export const getLoggedInUser = async (username) => {
  const userTokenUpdate = Cookies.get('token');
  const formData = { username };
  const data = JSON.stringify(formData);
  const urlEncode = 'application/x-www-form-urlencoded';
  if (userTokenUpdate) {
    try {
      return await axios.post('/user/profile', data, { headers: { 'Content-Type': `${urlEncode}`, 'device-id': `${deviceId}`, 'x-kumu-auth': `${userTokenUpdate}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};

export const getLiveStreamRegular = async (channel_id) => {
  const formData = new FormData();
  formData.append('id', channel_id);

  if (userToken) {
    try {
      return await axios.post('/live/regular-data', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.error(error);
      throw error;
    }
  } else {
    try {
      return await axios.post('/live/regular-data', formData, { headers: { 'device-id': `${deviceId}` } });
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
};

export const getVideoSlots = async (channel_id) => {
  const formData = new FormData();
  formData.append('channel_id', channel_id);

  if (userToken) {
    try {
      return await axios.post('live/video-slots', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.error(error);
      throw error;
    }
  } else {
    try {
      return await axios.post('live/video-slots', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.error('error: ', error);
      throw error;
    }
  }
};

export const getPastVideos = async (guid) => {
  if (Cookies.get('token')) {
    try {
      return await axios.get(`/user/get-ended-channel?query_id=${guid}`, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  } else {
    try {
      return await axios.get(`/user/get-ended-channel?query_id=${guid}`, { headers: { 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};

export const getKlipComments = async (feed_id, _page, _since_id) => {
  const formData = new FormData();
  formData.append('feed_id', feed_id);
  formData.append('page', _page);
  formData.append('since_id', _since_id);
  formData.append('is_new_comment', 1);
  try {
    return await axios.post('/feed/commentlist', formData, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.err(error);
    throw error;
  }
};

export const getStreamerSchedule = async (guid) => {
  try {
    return await axios.get(`/user/get-upcoming-channel?query_id=${guid}&from_date &to_date `, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.err(error);
    throw error;
  }
};
export const followStreamer = async (streamer_id, action) => {
  const formData = new FormData();
  const userTokenUpdate = Cookies.get('token');
  formData.append('influencer_id', streamer_id);
  formData.append('action', action);
  try {
    return await axios.post('/user/follow', formData, { headers: { 'x-kumu-auth': `${userTokenUpdate}`, 'device-id': `${deviceId}` } });
  } catch (error) {
    console.error('error: ', error);
    throw error;
  }
};
export const getUserInfo = async (user_id, channel_id) => {
  const formData = new FormData();
  formData.append('user_id', `${user_id}`);
  formData.append('channel_id', `${channel_id}`);
  try {
    return await axios.post('/user/info', formData, { headers: { 'x-kumu-auth': `${userToken}`, 'device-id': `${deviceId}` } });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const getUserKlips = async (guid, page, pageSize) => {
  const formData = new FormData();
  formData.append('query_id', guid);
  formData.append('page', page);
  formData.append('page_size', pageSize);
  formData.append('feed_type', 'video');
  formData.append('exclude_my_recordings', 1);

  if (Cookies.get('token')) {
    try {
      return await axios.post('feed/peek', formData, { headers: { 'x-kumu-auth': `${userToken}`, 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  } else {
    try {
      return await axios.post('feed/peek', formData, { headers: { 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};
export const getSelectedKlip = async (channel_id) => {
  const formData = new FormData();
  formData.append('channel_id', channel_id);
  try {
    return await axios.post('live/replay', formData, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.err(error);
    throw error;
  }
};

export const getLivestream = async (livestream_channel_id) => {
  const formData = new FormData();
  formData.append('id', livestream_channel_id);

  if (userToken) {
    try {
      return await axios.post('live/regular-data', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  } else if (userToken === undefined || userToken === null) {
    try {
      return await axios.post('live/regular-data', formData, { headers: { 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};

export const getEcommLive = async (ecomm_channel_id) => {
  const formData = new FormData();
  formData.append('id', ecomm_channel_id);
  if (userToken) {
    try {
      return await axios.post('live/ecomm-data', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  } else {
    try {
      return await axios.post('live/ecomm-data', formData, { headers: { 'device-id': `${deviceId}` } });
    } catch (error) {
      console.err(error);
      throw error;
    }
  }
};

export const getFilteredWords = async () => {
  try {
    return await axios.get('user/defaultsetting', { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.err(error);
    throw error;
  }
};
export const getAudioSlots = async (channel_id) => {
  const formData = new FormData();
  formData.append('channel_id', channel_id);
  try {
    if (userToken) {
      return await axios.post('live/audio-slots', formData, { headers: { 'device-id': `${deviceId}`, 'x-kumu-auth': `${userToken}` } });
    }
    return await axios.post('live/audio-slots', formData, { headers: { 'device-id': `${deviceId}` } });
  } catch (error) {
    console.err(error);
    throw error;
  }
};
